import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
import axiosInstance from "../../../../../../Utils/axios";
let cancelToken;

const purchaseReturnBranchURL = `api/v1/purchase-app/purchase-order-return`;

//obtaining the paginated data
export const getPurchaseReturnBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseReturnBranchURL}/list?party_type=branch_supplier&${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseReturnBranch = () =>
  axiosInstance.get(`${purchaseReturnBranchURL}/list?party_type=branch_supplier&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseReturnBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseReturnBranchURL}/list?party_type=branch_supplier&${paginationQueryParams(
      rowsPerPage,
      search,
      "",
      number
    )}`
  );
// get by id
export const getPurchaseReturnBranchById = (id) => axiosInstance.get(`${purchaseReturnBranchURL}/retrieve/${id}`);

export const getPurchaseInvoiceDetail = (id) =>
  axiosInstance.get(`api/v1/purchase-app/purchase-invoice/retrieve-for-purchase-return/${id}`);

export const getPurchaseReturnBranchAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createPurchaseReturnBranch = (body) => axiosInstance.post(`${purchaseReturnBranchURL}/create`, body);
//updating function
export const updatePurchaseReturnBranch = (id, body) =>
  axiosInstance.patch(`${purchaseReturnBranchURL}/update/${id}`, body);

//approve function
export const approvePurchaseReturnBranch = (id) => axiosInstance.patch(`${purchaseReturnBranchURL}/approve/${id}`);

//cancel function
export const cancelPurchaseReturnBranch = (id) => axiosInstance.patch(`${purchaseReturnBranchURL}/cancel/${id}`);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseReturnBranchURL}/list?party_type=branch_supplier&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
